import { INewUser } from '../interfaces/INewUser.interface';

export class NewUser implements INewUser {
	Id: number;
	UserName: string;
	Password: string;
	UserSalt: string;
	Token: string;
	IsActive: boolean;
	IsDeleted: boolean;
	ProfileId: number;
}


// WEBPACK FOOTER //
// ./src/app/models/NewUser.ts